<template>
  <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      style="min-height: 300px"
      pulling-text="下拉重新获取数据"
      loosing-text="释放即可重新加载"
      loading-text=""
      success-text="数据获取成功"
  >
    <div>
      <div
          class="top_tools_div"
          v-if="!channel_name || $common.isClient_hm()"
          :style="{
          backgroundColor: $common.transparent ? bg_color : '#FFFFFF',
          boxShadow: $common.transparent ? '' : '0px 1px 5px #999',
          top: 0,
        }"
      >
        <!--            <div style="width: 100%; min-height: 80px; background-color: white;position: sticky; z-index: 1999; box-shadow: 0px 1px 5px #999">-->
        <!--                <Wp_nav_bar v-if="$common.isClient_whole() && !no_jump_to_search" title="搜索"></Wp_nav_bar>-->

        <!-- <div
          :style="{
            width: '100%',
            height: 'env(safe-area-inset-top)',
            backgroundColor: $common.transparent ? bg_color : '#FFFFFF',
          }"
        ></div> -->
        <!-- 搜索 -->
        <div v-if="!jump_to_search">
          <van-row>
            <van-col
                v-if="changeling_span > 0"
                :span="changeling_span"
                style="text-align: center; padding-left: 5px"
            >
              <div v-if="show_logo" style="height: 52px; padding-top: 5px">
                <!--                                <div class="logo_icon" :style="{backgroundColor: $common.transparent ? font_color : '#ee0a24', color: $common.transparent ? bg_color : '#ffffff'}">万品</div>-->
                <!--                                <van-icon-->
                <!--                                        v-if="search_type_round"-->
                <!--                                        class="logo_icon"-->
                <!--                                        name="/images/wp_logo2.png"-->
                <!--                                        size="16"-->
                <!--                                        :style="{backgroundColor: $common.transparent ? font_color : '#ee0a24'}"-->
                <!--                                        :color="$common.transparent ? bg_color : '#ffffff'"-->
                <!--                                        @click="clickToChangeLink"-->
                <!--                                >-->
                <!--&lt;!&ndash;                                    <div style="font-size: 11px">万品</div>&ndash;&gt;-->
                <!--                                </van-icon>-->
                <!--                                <Wp_image class="logo_icon" url="/images/wp_logo2.png" :radius="5" fit="contain" :style="{backgroundColor: $common.transparent ? font_color : '#ee0a24',}"></Wp_image>-->
                <van-image
                    class="logo_icon"
                    :src="$common.transparent? '/images/wp_logo.png' : '/images/wp_logo2.png'"
                    height="42px"
                    fit="contain"
                    :radius="5"
                    @click="clickToChangeLink"
                ></van-image>
              </div>
              <div v-else>
                <div
                    v-if="$store.state.pid"
                    style="height: 52px; padding-top: 5.5px"
                >
                  <van-icon
                      v-if="search_type_round"
                      class="changelink_icon_round"
                      name="exchange"
                      size="16"
                      :style="{
                      backgroundColor: $common.transparent
                        ? font_color
                        : '#ee0a24',
                    }"
                      :color="$common.transparent ? bg_color : '#ffffff'"
                      @click="clickToChangeLink"
                  >
                    <div style="font-size: 11px">转链</div>
                  </van-icon>
                  <van-icon
                      v-else
                      class="changelink_icon"
                      name="exchange"
                      size="16"
                      :style="{
                      backgroundColor: $common.transparent
                        ? font_color
                        : '#ee0a24',
                    }"
                      :color="$common.transparent ? bg_color : '#ffffff'"
                      @click="clickToChangeLink"
                  >
                    <div style="font-size: 11px">转链</div>
                  </van-icon>
                </div>

                <div v-else style="height: 52px; padding-top: 5.5px">
                  <van-icon
                      v-if="search_type_round"
                      class="changelink_icon_round"
                      name="search"
                      size="16"
                      :style="{
                      backgroundColor: $common.transparent
                        ? font_color
                        : '#ee0a24',
                    }"
                      :color="$common.transparent ? bg_color : '#ffffff'"
                      @click="clickToSearchCoupon"
                  >
                    <div style="font-size: 11px">搜券</div>
                  </van-icon>
                  <van-icon
                      v-else
                      class="changelink_icon"
                      name="search"
                      size="16"
                      :style="{
                      backgroundColor: $common.transparent
                        ? font_color
                        : '#ee0a24',
                    }"
                      :color="$common.transparent ? bg_color : '#ffffff'"
                      @click="clickToSearchCoupon"
                  >
                    <div style="font-size: 11px">搜券</div>
                  </van-icon>
                </div>
              </div>
            </van-col>
            <van-col :span="24 - changeling_span">
              <Wp_search_model
                  :search-value="search_value"
                  :font-color="font_color"
                  :bg-color="bg_color"
                  :default-click-search="default_click_search"
                  :common-transparent="$common.transparent"
                  :round="search_type_round"
                  @clickToSearch="clickToSearch"
                  @searchInputClick="searchInputClick"
                  @getSearchValue="getSearchValue"
                  :style="{ marginLeft: search_type_round ? '-9px' : '' }"
              ></Wp_search_model>
              <div
                  :style="{
                  height: '52px',
                  width: $common.screenWidth + 'px',
                  position: 'absolute',
                  top: '0px',
                }"
                  @click="clickToAllSearchPage"
              ></div>
            </van-col>
          </van-row>
        </div>

        <!-- 二级域名或河马 -->
        <div
            v-if="
            ($common.isClient() && !channel_name && jump_to_search) ||
            $common.isClient_hm()
          "
        >
          <div style="display: flex; align-items: center">
            <!--                        <div style="text-align: center; margin-top: -8px; padding-left: 2px; color: #EE0A24">返回钱兔</div>-->
            <div v-if="show_qtt" style="width: 100px; text-align: center">
              <van-button
                  type="danger"
                  round
                  plain
                  style="height: 35px; line-height: 35px"
                  @click="clickBackToQt"
              >返回钱兔
              </van-button>
            </div>
            <div style="flex: 1" @click="clickSearch">
              <Wp_search_model
                  style
                  :font-color="font_color"
                  :common-transparent="$common.transparent"
              ></Wp_search_model>

              <div
                  :style="{
                  height: '52px',
                  width: $common.screenWidth + 'px',
                  position: 'absolute',
                  top: '0px',
                }"
              ></div>
            </div>
          </div>
        </div>

        <!-- 分类 -->
        <div :style="{display: hide_category ? 'none' : ''}">
<!--        <div :class="hide_category ? 'category_hide' : 'category_show'">-->
          <!--                分类-->
          <JdCategoryTabs
              ref="jdCategoryTabs"
              :show-tabs-home="showTabsHome"
              @onSelect="selectCategory"
          ></JdCategoryTabs>
        </div>

        <div v-if="!showHome" id="checkbox_sort_div" :class="checkbox_sort_div">
          <!-- 优惠券选项 -->
          <van-checkbox-group v-model="check_result" @change="onCheckBoxChange">
            <van-row
                style="margin-left: 15px; margin-top: 10px; margin-bottom: 10px"
            >
              <van-col span="7">
                <van-checkbox
                    :name="check_list[0]"
                    shape="round"
                    checked-color="#ff0000"
                >{{ check_list[0] }}
                </van-checkbox>
              </van-col>
              <van-col span="7">
                <van-checkbox
                    :name="check_list[1]"
                    shape="round"
                    checked-color="#ff0000"
                >{{ check_list[1] }}
                </van-checkbox>
              </van-col>
              <van-col span="5">
                <van-checkbox
                    :name="check_list[2]"
                    shape="round"
                    checked-color="#ff0000"
                >{{ check_list[2] }}
                </van-checkbox>
              </van-col>
              <van-col span="5">
                <van-checkbox
                    :name="check_list[3]"
                    shape="round"
                    checked-color="#ff0000"
                >{{ check_list[3] }}
                </van-checkbox>
              </van-col>
            </van-row>
          </van-checkbox-group>

          <van-row v-if="!$common.isClient_whole()">
            <van-col span="20">
              <!-- 排序选项 -->
              <JdSortTabs
                  v-if="!$common.isClient_whole()"
                  ref="jdSortTabs"
                  @onSelect="onSortSelect"
              ></JdSortTabs>
            </van-col>
            <van-col span="4">
              <Wp_options_filter_model
                  @getFilterData="getFilterData"
              ></Wp_options_filter_model>
            </van-col>
          </van-row>
        </div>
      </div>
      <div v-if="!showHome">
<!--          <div style="margin-top: 190px"><van-button @click="test">测试</van-button></div>-->
        <div
            v-if="list"
            :style="{
            position: 'relative',
            top: $common.isClient_whole() ? '160px' : '190px',
            marginBottom: '190px',
            minHeight: '250px',
          }"
        >
          <!--            <div v-if="list" style="position: relative;top:10px; margin-bottom: 180px">-->

          <div v-if="!$common.isClient_whole()">
            <!-- <div v-if="$common.getPid()" style="margin-left: 15px; font-size: 12px; color: red">
                                                    *预估佣金与实际佣金可能不同，请以订单中的佣金为准<br/>
                                                    *企业账号下单购买，无佣金
                                    </div>-->
          </div>

          <!--                滚动banner-->
          <div v-if="pop_datas && pop_datas.show === 1 && pop_datas.banner_img">
            <Wp_img_swipe
                style="padding: 0px 10px"
                round
                :list="[{ img: pop_datas.banner_img }]"
                @clickImage="clickBannerImage"
            ></Wp_img_swipe>
          </div>

          <van-list
              v-model="loading"
              :finished="finished"
              :finished-text="finishedText"
              @load="onLoad"
          >
            <div v-if="$common.getPid()">
              <!--                        <div v-if="$store.state.pid">-->
              <JdSkuInfoCard
                  ref="JdSkuInfoCard"
                  v-for="(sku_info, index) in list"
                  v-bind:key="index"
                  :skuInfo="sku_info"
                  @addInSelectList="addInSelectList"
                  @getAllRobatSkuData="getAllRobatSkuData"
                  @updataBadegSync="updataBadegSync"
              ></JdSkuInfoCard>
            </div>

            <div v-else>
              <JdSkuInfoCard_No_Pid
                  v-for="(sku_info, index) in list"
                  v-bind:key="index"
                  :skuInfo="sku_info"
                  @addInSelectList="addInSelectList"
              ></JdSkuInfoCard_No_Pid>
            </div>
          </van-list>

          <!--                    <div v-if="select_skuInfo_list && select_skuInfo_list.length > 0"-->
          <!--                         style="position: fixed; right: -1px; bottom: 130px">-->
          <!--                        <Badge :count="select_skuInfo_list.length" style="position: absolute;"></Badge>-->
          <!--                        <van-button-->
          <!--                                style="margin-left: 9px; margin-top: 9px;"-->
          <!--                                type="danger"-->
          <!--                                @click="showSelectList"-->
          <!--                        >选品清单-->
          <!--                        </van-button>-->
          <!--                    </div>-->

          <!--                    &lt;!&ndash;选品清单sheet&ndash;&gt;-->
          <!--                    <JdSelectListSheet ref="jdSelectListSheet"></JdSelectListSheet>-->

          <Wp_select_list_mark_model
              ref="Wp_select_list_mark_model"
          ></Wp_select_list_mark_model>
        </div>
      </div>

      <div v-else>
        <div>
          <Wp_jd_home ref="Wp_jd_home"></Wp_jd_home>
        </div>
      </div>
    </div>

    <!--        <Wp_pop_activities v-if="pop_datas && pop_datas.show === 1 && pop_datas.pop_img" :show-pop="show_pop_activities" :image="pop_datas.pop_img" @clickImage="clickImage"></Wp_pop_activities>-->

    <Wp_pop_action
        v-if="pop_datas && pop_datas.length > 0"
        :show-pop="show_pop_activities"
        :pop-data="pop_datas"
        @clickImage="clickPopImage"
    ></Wp_pop_action>

    <!--        <div v-if="allRobotSkuData">-->
    <!--            <Wp_join_robot_list_mark_model ref="Wp_join_robot_list_mark_model"-->
    <!--                                           :all-robot-sku-data="allRobotSkuData"-->
    <!--                                           @updataJoinRobotButtonStatus="updataJoinRobotButtonStatus"-->
    <!--            ></Wp_join_robot_list_mark_model>-->
    <!--        </div>-->
  </van-pull-refresh>
</template>

<script>
import Vue from 'vue'
import { Divider, Table, Icon, Badge, Alert } from 'iview'
import JdSkuInfoCard from '../custom/JdSkuInfoCard'
import JdCategoryTabs from '../custom/JdCategoryTabs'
import JdSortTabs from '../custom/JdSortTabs'
import JdSkuInfoCard_No_Pid from '../custom/JdSkuInfoCard_No_Pid'
import Wp_img_swipe from '../custom/Wp_img_swipe'
import Wp_jd_home from './Wp_jd_home'
import Wp_pop_action from '../custom/Wp_pop_action'
import Wp_search_model from '../custom/Wp_search_model'
import Wp_nav_bar from '../custom/Wp_nav_bar'
import Wp_select_list_mark_model from '../custom/Wp_select_list_mark_model'
import Wp_join_robot_list_mark_model from '../custom/Wp_join_robot_list_mark_model'
import Wp_jd_home_simple from './Wp_jd_home_simple'
import Wp_options_filter_model from '../custom/Wp_options_filter_model'

Vue.component('Divider', Divider)
Vue.component('i-table', Table)
Vue.component('Icon', Icon)
Vue.component('Badge', Badge)
Vue.component('Alert', Alert)

import { Toast } from 'vant'
import Wp_image from '../custom/Wp_image'

export default {
  name: 'Wp_jd_select',
  components: {
    Wp_image,
    Wp_options_filter_model,
    Wp_jd_home_simple,
    Wp_join_robot_list_mark_model,
    Wp_select_list_mark_model,
    Wp_nav_bar,
    Wp_search_model,
    Wp_pop_action,
    Wp_jd_home,
    Wp_img_swipe,
    JdSkuInfoCard_No_Pid,
    JdSortTabs,
    JdCategoryTabs,
    JdSkuInfoCard,
  },

  //子组件中可通过相应配置，获得父组件的this
  provide () {
    return {
      JdSelectListSheet_parent: this,
    }
  },

  data () {
    return {
      all_params: this.$getSelectGoodsParams(),
      jf_params: this.$getSelectJFGoodsParams(),
      // sku_info:null
      base_data_array: null,
      check_list: ['优惠券', '京东自营', '拼购', '爆款'],
      check_result: ['优惠券'],
      search_value: '',
      category_list: [],
      selecedCatgoryInfo: {},
      // jdCategoryTabs_active: "0",

      //下拉刷新结束
      isLoading: false,

      //上拉加载的临时list
      list: [],
      //上拉加载状态结束
      loading: false,
      //数据全部加载完成的状态
      finished: false,

      finishedText: '已获取全部数据',

      //请求数据页码
      page_index: 1,
      //一次页面请求多少数据
      page_size: 20,

      // //选品清单，内容为skuId
      // select_skuId_list: [],
      // //选品清单中的商品信息集合
      // select_skuInfo_list: [],
      //
      // //添加到选品清单中的商品数量上限
      // select_sku_length_limit: 9,

      //滚动条到顶部的距离的临时存储
      scroll_top_temp: 0,
      //checkbox_sort_div对应的div的class的值
      checkbox_sort_div: 'checkbox_sort_div_show',
      //用于判断向下或向上滚动时，只操作一次checkbox_sort_div的值
      scroll_once_temp: true,
      //承载转链的van-col的span
      changeling_span: 3,

      url_param_value: '',

      pop_datas: null,

      show_pop_activities: false,

      showHome: false,

      bg_color: '',
      font_color: '',

      //是否显示tabs的"推荐"标签
      showTabsHome: true,

      autoLoad: true,

      hasCheckBoxParam: false,
      //默认点击选中搜索框
      default_click_search: false,

      jump_to_search: false,

      search_type_round: true, //搜索框是否使用圆弧样式

      channel_name: '',
      // Wp_join_robot_list_mark_model: null,

      allRobotSkuData: null,

      temp_allRobotSkuData: null,

      JdSkuInfoCard_From_Wp_home_more_model: [],

      show_qtt: false, //显示返回钱兔按钮

      show_logo: false, //左上角是否显示“万品”logo

        hide_category: false,//隐藏类别标签
    }
  },

  watch: {
    // '$common.bg_color'(newColor){
    //     this.$log("--------newColor = " + newColor)
    // },
    // getBgColor:{
    //     handler: function() {
    //         this.$log("--------watch----getBgColor-----------")
    //     },
    //     // handler(newColor){
    //     //     this.$log("--------newColor = " + newColor)
    //     // },
    //     deep: true
    // },
    // getColor(newColor){
    //     this.$log("--------newColor = " + newColor)
    // }
  },

  computed: {
    // getBgColor:{
    //     get(){
    //         return this.$common.bg_color;
    //     },
    //     set(val){
    //         this.$log("--------computed-----val----------- = " + val)
    //     }
    // },
    // getBgColor: function () {
    //
    //     this.$log("--------computed-----getBgColor-----------")
    //     return this.$common.bg_color;
    // },
  },

  created () {
    // this.$getPid('s1888')
    this.$log('this.$config.project = ' + this.$config.project)
    // this.$log("md5 = " + this.$md5("13121342816").toUpperCase());

    this.$capUtils.getDeviceInfo((res) => {
      if (res) {
        let platform = res.platform.toLowerCase()
        // this.changeling_span = 4;
        if (platform === 'ios' || platform === 'android') {
          this.show_logo = true
          this.changeling_span = 4
        }
      }
    })

    if (!this.$common.isClient_whole()) {
      if (!this.$common.gloabl_wx_openid) {
        //判断是否弹出登录界面
        let isLogin = this.$store.getters.isLogin
        // this.$log("isLogin = " + isLogin);
        if (isLogin !== true) {
          this.$bus.$emit('toLogin', '登录吧,牛宝宝')
        } else {
          this.getPopDatas()
        }
      } else {
        this.getPopDatas()
      }

      this.getRobotList()
    }

    let cid = this.$common.getUrlKey('cid')
    if (cid) {
      this.autoLoad = false
    }

    // let paras = {
    //     ext_user: '13520453643',
    //     // stime: '2020-01-01',
    //     // etime: '2020-01-01'
    // };
    // this.$getReturnCashData(paras, response=>{
    //     // {msg: "无数据", code: 3001}
    //     this.$log("1111---response")
    //     this.$log(response)
    // })

    let _show_qtt = this.$common.getUrlKey('from')
    if (_show_qtt === 'qtt') {
      this.show_qtt = true
    }
  },

  mounted () {
    // if(this.$store.state.pid){
    //     this.changeling_span = 3;
    // }else{
    //     this.changeling_span = 0;
    // }

    let value = this.$common.getUrlKey('search')
    if (value) {
      this.url_param_value = decodeURIComponent(value)
      if (this.url_param_value) {
        this.search_value = this.url_param_value
        // this.changeling_span = 0;
      }
    }

    //如果有"推荐"页
    if (
        this.$refs.jdCategoryTabs &&
        this.$refs.jdCategoryTabs.category_list[0].grade === '-2'
    ) {
      this.showHome = true
      this.$common.transparent = true
    }

    //如果有筛选相关的checkbox内容
    let box = this.$common.getUrlKey('box')
    // this.$log("box = " + box);
    this.initCheckBoxByParam(box)

    //初始化参数
    this.initAllParams()

    window.addEventListener('scroll', this.scrollListener, true)

    //二级页面原方式，使用home_s为首页
    // if(this.$common.isClient_whole()){
    //
    //     this.showHome = false;
    //     this.showTabsHome = false;
    //     this.$common.transparent = false;
    //
    //     this.selectCategrayTab("0");
    //
    //     //隐藏转链按钮
    //     this.changeling_span = 0;
    //
    //     //如果包含isInput参数，表面是从二级页面点击搜索框跳转过来的，所以默认触发搜索框的焦点
    //     let isInput = this.$common.getUrlKey('isInput');
    //     if(isInput && isInput === 'true'){
    //         this.default_click_search = true;
    //     }
    // }

    //二级页面新：仍使用select为首页
    if (this.$common.isClient_whole()) {
      this.channel_name = this.$common.getUrlKey('channel_name')

      this.jump_to_search = true

      //隐藏转链按钮
      this.changeling_span = 0

      //如果包含isInput参数，表面是从二级页面点击搜索框跳转过来的，所以默认触发搜索框的焦点
      // let isInput = this.$common.getUrlKey('isInput');
      // if(isInput && isInput === 'true'){
      //     this.default_click_search = true;
      // }
    }

    // this.$refs.Wp_join_robot_list_mark_model.initRobotSkuListMark();

    // if(this.$common.static_scroll_top > 0){
    //
    //     this.$log("22 this.$common.static_scroll_top = " + this.$common.static_scroll_top);
    //     setTimeout(()=>{
    //         document.documentElement.scrollTop = this.$common.static_scroll_top;
    //         // window.pageYOffset = this.$common.static_scroll_top;
    //         document.body.scrollTop = this.$common.static_scroll_top;
    //
    //
    //         this.$common.static_scroll_top = 0;
    //     }, 500)
    // }
  },

  destroyed () {
    window.removeEventListener('scroll', this.scrollListener)
  },

  methods: {
      test(){
          // let url = encodeURIComponent("https://u.jd.com/zspfpcz");
          let url = "https://u.jd.com/zspfpcz";
          this.$common.navigateToMiniProgramPage('../wp_jump_jd/wp_jump_jd?', 'url', url)
      },
    clickBackToQt () {
      window.location.replace('http://joy.qiantutu.com/')
    },

    getFilterData (filterData) {
      this.initStatus()

      this.all_params.pricefrom = filterData.price_min
      this.all_params.priceto = filterData.price_max
      this.all_params.commissionShareStart = filterData.commission_share_min
      this.all_params.commissionShareEnd = filterData.commission_share_max

      this.onLoad()
    },

    clickSearch () {
      this.$router.push('search_page?isInput=true')
    },
    clickToAllSearchPage () {
      this.$goto('all_search')
    },

    /**
     * 获取群主提交到助理的数据列表
     */
    initSkuListFromRobot () {
      this.$getAllDataListFromRobot_withLimitTime()

      setTimeout(() => {
        this.allRobotSkuData = this.$common.global_sku_all_data
      }, 500)
    },

    /**
     * 更新角标（来自JdSkuInfoCard）
     */
    updataBadegSync (addOne) {
      // if(this.Wp_join_robot_list_mark_model){
      //     this.Wp_join_robot_list_mark_model.updataBadegSync(addOne);
      // }
      if (this.$refs.Wp_join_robot_list_mark_model) {
        this.$refs.Wp_join_robot_list_mark_model.updataBadegSync(addOne)
      }
    },

    /**
     * 获取全部数据（来自JdSkuInfoCard）
     */
    getAllRobatSkuData (data) {
      // if(this.$refs.Wp_join_robot_list_mark_model){
      //     this.$refs.Wp_join_robot_list_mark_model.getAllRobatSkuData(data);
      // }
      this.allRobotSkuData = data
    },

    /**
     * Wp_home_more_model里调用传值过来
     */
    getAllRobatSkuDataFrom_Wp_home_more_model (data, JdSkuInfoCard) {
      this.allRobotSkuData = data
      this.JdSkuInfoCard_From_Wp_home_more_model = JdSkuInfoCard
    },

    /**
     * 更新按钮状态
     */
    updataJoinRobotButtonStatus () {
      // this.$log("11111111111112")
      //JdSkuInfoCard_From_Wp_home_more_model为 Wp_home_more_model里边传过来的this.$refs.JdSkuInfoCard
      if (this.JdSkuInfoCard_From_Wp_home_more_model) {
        // this.$log("2222222222222222222")
        for (
            let i = 0;
            i < this.JdSkuInfoCard_From_Wp_home_more_model.length;
            i++
        ) {
          this.JdSkuInfoCard_From_Wp_home_more_model[
              i
              ].updateJoinRobotButtonStatus()
        }
      }
      if (this.$refs.JdSkuInfoCard) {
        for (let i = 0; i < this.$refs.JdSkuInfoCard.length; i++) {
          this.$refs.JdSkuInfoCard[i].updateJoinRobotButtonStatus()
        }
      }
    },

    /**
     * 获取机器人列表
     */
    getRobotList () {
      this.$getRobotList()
    },

    getSearchValue (value) {
      this.search_value = value
    },

    /**
     * 初始化复选框（根据请求链接中的box参数）
     */
    initCheckBoxByParam (box) {
      if (box) {
        this.hasCheckBoxParam = true
        if (box.indexOf(';') !== -1) {
          let check_indexs = box.split(';')
          this.check_result = []
          for (let i = 0; i < check_indexs.length; i++) {
            this.check_result.push(this.check_list[check_indexs[i]])
          }
        } else {
          this.check_result = []
          this.check_result.push(this.check_list[box])
        }
      }
    },

    /**
     * 初始化选中某个分类（根据请求链接中的参数进行选中）
     */
    initCategrayTabSelected () {
      let grade = this.$common.getUrlKey('grade')
      let cid = this.$common.getUrlKey('cid')
      // this.$log("grade = " + grade);
      // this.$log("cid = " + cid);
      if (grade && cid) {
        // //恢复加载数据
        // this.autoLoad = true;
        //
        // this.selectCategrayTab(cid);

        let ids = ''
        if (
            this.$refs.jdCategoryTabs &&
            this.$refs.jdCategoryTabs.category_list
        ) {
          for (
              let i = 0;
              i < this.$refs.jdCategoryTabs.category_list.length;
              i++
          ) {
            // if(this.$refs.jdCategoryTabs.category_list[i].id === cid){
            //
            // }
            ids += this.$refs.jdCategoryTabs.category_list[i].id + ';'
          }
        }
        // this.$log(ids)
        if (ids && ids.indexOf(cid) !== -1) {
          //恢复加载数据
          this.autoLoad = true

          this.selectCategrayTab(cid)
        } else {
          let category_name = this.$common.getUrlKey('category_name')
          if (category_name) {
            category_name = decodeURIComponent(category_name)
          }

          let selectData = {
            grade: grade,
            id: cid,
            img: '',
            name: category_name,
            parentId: '',
          }

          if (category_name) {
            if (
                this.$refs.jdCategoryTabs &&
                this.$refs.jdCategoryTabs.category_list
            ) {
              this.$refs.jdCategoryTabs.category_list.push(selectData)
            }

            //恢复加载数据
            this.autoLoad = true

            this.selectCategrayTab(cid)
          } else {
            //类别名称没有的话，则定位到"全部"
            this.selectCategrayTab('-1')

            //恢复加载数据
            this.autoLoad = true

            this.selectCategory(selectData)
          }
        }
      }
    },

    // searchInputFocus(){
    //     this.$log("input ----- foucus")
    // },
    /**
     * 点击搜索框时，将JdCategoryTabs定位到"全部"
     */
    searchInputClick (id) {
      this.selectCategrayTab(id)
    },

    selectCategrayTab (id) {
      this.$refs.jdCategoryTabs.active_model = id
      this.$refs.jdCategoryTabs.onSelect(id)
    },

    clickBannerImage () {
      this.clickImage()
    },

    clickImage () {
      this.$log(this.pop_datas)
      if (this.$common.static_action_info_datas) {
        this.$router.push('pop_activities_page')
      }
    },

    clickPopImage (datas) {
      this.$log(this.pop_datas)
      if (datas) {
        this.$common.static_action_info_datas = datas
        this.$router.push('action_info')
      }
    },

    /**
     * 获取插屏数据
     */
    getPopDatas () {
      let params = {
        page: 1,
        size: 20,
        type: '4',
      }

      let url = this.$common.get_action_list

      this.$getDatasWithUrlAndParams(url, params, (response) => {
        // start_time: "2020-01-14 15:10:43"
        // createtime: "2020-01-17 12:27:03"
        // act_name: "关于12月佣金提现通知"
        // act_share_img: ""
        // act_desc: ""
        // end_time: "2020-01-20 23:59:59"
        // show: 0
        // act_type: "1,2,3,4,"
        // act_content: "临近春节，为了让广大会员可在年前提现，本平台将于2020年1月份结算日提前至1月16日。↵↵       凡是在1月16日、17日、18日、19日、20日提现的会员，我们将在22号之前完成打款，21日后提现的群主顺延至下个月2月21日后打款，届时请您尽快在后台进行提现。↵↵       感谢您对万品京选平台的大力支持！"
        // id: "A_1578985843000"
        // pop_img: "http://api.wapg.cn/jd_union/images/20200117/d66247c9c21b5cd86adf90b8bfa9de6a.png"
        if (response && response.code === 200) {
          if (
              response.data &&
              response.data.list &&
              response.data.list.length > 0
          ) {
            // 根据show获取可显示的插屏
            let datas = response.data.list
            let pop_temp = []
            for (let i = 0; i < datas.length; i++) {
              if (datas[i].show === 0) {
                pop_temp.push(datas[i])
              }
            }

            this.pop_datas = pop_temp
            this.$common.static_pop_datas = pop_temp

            // this.pop_datas = response.data.list;
            // this.$common.static_action_info_datas = response.data.list;

            // let user = this.$store.state;
            // user.show_pop_time = new Date();
            let current_time = Date.parse(new Date())
            let old_time = this.$store.state.show_pop_old_time
            if (current_time - old_time > 1000 * 60) {
              this.$store.commit('setShowPopOldTime', current_time)
              this.show_pop_activities = true
            } else {
              this.show_pop_activities = false
            }
          }
        }
      })
    },

    // clickToBack(){
    //     this.$wx.miniProgram.navigateBack();
    // },

    clickToChangeLink () {
      // this.$router.push("changelink?from=select");
      // if(!this.$store.state.pid || !this.$common.gloabl_wx_mini_user_info || !this.$common.gloabl_wx_mini_user_info.channel_id){
      if (this.$store.state.pid) {
        this.$router.push('changelink')
      } else {
        if (this.$config.project === 'mini' || this.$common.gloabl_wx_openid) {
          this.$dialog
              .alert({
                title: '提示',
                message:
                    '普通会员无法使用转链功能，请升级为超级会员后再进行使用；\n\n若您已经是超级会员或以上级别仍无法使用，请前往[我的]清空缓存，然后再使用转链功能',
              })
              .then(() => {
                // this.$common.switchTabMiniProgramPage("../wp_guide/wp_guide");
                // this.$wx.miniprogram.navigateBack();
              })
        } else {
          this.$dialog.alert({
            title: '提示',
            message: '转链所需必要参数（pid）异常',
          })
        }
      }
    },

    clickToSearchCoupon () {
      if (this.$store.state.pid) {
        this.$router.push('changelink')
      } else {
        if (this.$config.project === 'mini' || this.$common.gloabl_wx_openid) {
          this.$common.navigateToMiniProgramPage('../wp_search/wp_search')
        }
      }
    },

    /**
     * 选品界面中的滚动条的监听
     */
    scrollListener () {
      //滚动条距离顶部距离
      let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
      // this.$log("window.pageYOffset = " + window.pageYOffset)
      // this.$log("document.documentElement.scrollTop = " + document.documentElement.scrollTop)
      // this.$log("document.body.scrollTop = " + document.body.scrollTop)

      if (this.scroll_top_temp <= scrollTop && scrollTop > 80) {
        //向下滚动时隐藏筛选和排序
        // checkbox_sort_div.style.display = 'none';

        if (this.scroll_once_temp) {
          this.checkbox_sort_div = 'checkbox_sort_div_hide'
          this.scroll_once_temp = false
        }
          if(this.showHome){
              this.hide_category = true;

              this.$bus.$emit("more_tab_margin_top", '52px');
          }

      } else {
        //向上滚动时显示筛选和排序
        // checkbox_sort_div.style.display = 'block';

        if (!this.scroll_once_temp) {
          this.checkbox_sort_div = 'checkbox_sort_div_show'
          this.scroll_once_temp = true
        }

          if(this.showHome && scrollTop < 100){
              this.hide_category = false;

              this.$bus.$emit("more_tab_margin_top", '95px');
          }
      }

      this.scroll_top_temp = scrollTop

      //如果this.$common.global_sku_all_data有更新，则更新this.allRobotSkuData数据
      if (this.temp_allRobotSkuData !== this.$common.global_sku_all_data) {
        //如果缓存的temp_allRobotSkuData与this.$common.global_sku_all_data不同，则说明this.$common.global_sku_all_data有数据更新，
        this.allRobotSkuData = this.$common.global_sku_all_data
        this.temp_allRobotSkuData = this.$common.global_sku_all_data
        //更新按钮状态
        this.updataJoinRobotButtonStatus()
        // this.$log("00000000000000000")
      } else {
        // this.$log("aaaaaaaaaaaaaaaaaaaa")
      }
    },

    /**
     * 选择类别tab的监听
     */
    selectCategory (categoryData) {
      this.$log(categoryData)
      if (categoryData) {
        this.selecedCatgoryInfo = categoryData

        this.initStatus()

        if (this.selecedCatgoryInfo) {
          // this.jdCategoryTabs_active = this.selecedCatgoryInfo.id;

          if (this.selecedCatgoryInfo.id !== '0') {
            if (this.selecedCatgoryInfo.grade === '-2') {
              //显示"推荐"页——首页
              this.showHome = true
              this.search_value = ''
              this.$common.transparent = true
              // this.jump_to_search = true;
              if (this.$config.project === 'mini') {
                this.$common.navigateBack()
              }
            } else {
              this.showHome = false
              this.$common.transparent = false
              // this.jump_to_search = false;

              if (this.selecedCatgoryInfo.grade === '0') {
                this.all_params.cid1 = this.selecedCatgoryInfo.id
              } else {
                this.all_params.cid1 = -1
              }

              if (this.selecedCatgoryInfo.grade === '1') {
                this.all_params.cid2 = this.selecedCatgoryInfo.id
              } else {
                this.all_params.cid2 = -1
              }

              if (this.selecedCatgoryInfo.grade === '2') {
                this.all_params.cid3 = this.selecedCatgoryInfo.id
              } else {
                this.all_params.cid3 = -1
              }
            }
          } else {
            this.showHome = false
            this.$common.transparent = false
            // this.jump_to_search = false;
            //全部
            this.all_params.cid1 = -1
            this.all_params.cid2 = -1
            this.all_params.cid3 = -1
          }
        }

        if (!this.showHome) {
          this.onLoad()
        }
      }
    },

    // /**
    //  * 显示商品清单
    //  */
    // showSelectList() {
    //     // this.getSelectSkuList();
    //     if (this.select_skuInfo_list && this.select_skuInfo_list.length > 0) {
    //         // this.showSelect = true;
    //         this.$refs.jdSelectListSheet.showSelect = true;
    //     }
    // },

    /**
     * 添加商品到选品清单中
     */
    addInSelectList (skuInfo, skuId) {
      this.$refs.Wp_select_list_mark_model.addInSelectList(skuInfo, skuId)
      // if (this.select_skuInfo_list.length === this.select_sku_length_limit) {
      //     this.$dialog.alert({
      //         message: '[选品清单]以达到最大限额'
      //     });
      //     return;
      // }
      //
      // if (this.select_skuId_list.includes(skuId)) {
      //     // this.$toast.fail("该商品已加入[选品清单]")
      //     this.$dialog.alert({
      //         message: '该商品已加入[选品清单]'
      //     });
      // } else {
      //     this.select_skuInfo_list.push(skuInfo)
      //     this.select_skuId_list.push(skuId)
      // }
    },

    /**
     * 排序选项被选中
     */
    onSortSelect (label, sort) {
      this.all_params.sortName = label
      this.all_params.sort = sort

      this.initStatus()

      this.onLoad()
    },

    /**
     * 上拉加载
     */
    onLoad () {
      this.initSkuListFromRobot()

      if (!this.autoLoad) {
        return
      }
      if (!this.showHome && !this.$common.isClient_whole()) {
        //选品清单重置(因为修改为判断showHome的方式，当onLoad被调用时，this.$refs.jdSelectListSheet可能为空，所以延时50毫秒)
        setTimeout(() => {
          this.$refs.Wp_select_list_mark_model.releaseSelectData()
        }, 50)
      }

      this.loading = true
      // 更新数据
      if (this.all_params.app_key) {
        //设置最新的页码
        this.getGoodsDataWithParams(this.all_params, (datas) => {
          this.loadDatas(datas)
        })
      } else {
        this.initAllParams()
        //没有查询参数，获取全部数据
        this.getGoodsDataWithParams(this.all_params, (datas) => {
          this.loadDatas(datas)
        })
      }
    },

    loadDatas (datas) {
      if (datas) {
        //list一次加载的数据
        // let data_size = this.page_size;
        // //如果总数据数组的length小于没次加载的限制值，则直接使用数组length
        // if (data_size === 0) {
        //     data_size = datas.length;
        //     //如果一次获取到的数据，小于限制的数值，则表示数据已全部获取完成
        //     this.finished = true;
        // } else {
        //     this.finished = false;
        // }

        if (datas.length === 1 && this.list.length === 1) {
          this.$log(
              'this.list.indexOf(datas[0]) = ' +
              (this.list[0].skuId === datas[0].skuId)
          )
          if (this.list[0].skuId === datas[0].skuId) {
            // 加载状态结束
            this.loading = false
            // 获取数据结束
            this.finished = true
            this.finishedText = '已获取全部商品~'
            return
          }
        }

        for (let i = 0; i < this.page_size; i++) {
          if (datas[i]) {
            this.list.push(datas[i])
          }
        }
        // this.list = datas;

        // 加载状态结束
        this.loading = false

        this.all_params.pageIndex += 1
      } else {
        // 加载状态结束
        this.loading = false
        // 获取数据结束
        this.finished = true
        this.finishedText = '已获取全部商品~'
        if ((!this.list || this.list.length === 0) && this.url_param_value) {
          this.finishedText = '未搜索到相关商品'
        }
      }
      //关闭下拉刷新
      this.isLoading = false
    },

    /**
     * 下拉刷新
     */
    onRefresh () {
      if (this.showHome) {
        if (this.$refs.Wp_jd_home) {
          //关闭下拉刷新
          this.isLoading = false

          this.$refs.Wp_jd_home.refreshHome()
          this.$refs.Wp_jd_home.initComponentDatas()

          // this.finished = true;
          // this.loading = false;
        }
      } else {
        this.initStatus()

        this.onLoad()
        // window.location.reload();

        this.pop_datas = null
        this.getPopDatas()
      }
    },

    /**
     * 根据条件查询数据
     */
    clickToSearch () {
      // this.list = [];
      // this.all_params.pageIndex = 1;
      // this.finished = false;
      // this.loading = true;

      this.initStatus()

      this.all_params.keyword = this.search_value

      //类别tab标签重置
      this.selectCategrayTab('-1')
      // this.$refs.jdCategoryTabs.active_model = "0";

      // this.jdCategoryTabs_active = "0";
      this.all_params.cid1 = -1
      this.all_params.cid2 = -1
      this.all_params.cid3 = -1

      //手动调用onLoad方法获取数据
      this.onLoad()
    },

    /**
     * 复选框筛选条件改变的回调
     */
    onCheckBoxChange (check_values) {
      this.initStatus()

      //优惠券
      if (check_values.includes(this.check_list[0])) {
        this.all_params.isCoupon = 1
      } else {
        this.all_params.isCoupon = -1
      }
      //京东自营
      if (check_values.includes(this.check_list[1])) {
        this.all_params.owner = 'g'
      } else {
        this.all_params.owner = ''
      }
      //拼购
      if (check_values.includes(this.check_list[2])) {
        this.all_params.isPG = 1
      } else {
        this.all_params.isPG = -1
      }
      //爆款
      if (check_values.includes(this.check_list[3])) {
        this.all_params.isHot = 1
      } else {
        this.all_params.isHot = -1
      }

      this.onLoad()
    },

    /**
     * 重新获取数据时，重新初始化各种状态
     */
    initStatus () {
      this.list = []
      this.all_params.pageIndex = 1

      this.finished = false
      this.loading = true
    },

    /**
     * 获取所有数据(不指定特别参数)
     * @param fn 是否运行onLoad，对于选择不同标签以及搜索的结果，都需要调用onLoad()，需要传入true
     */
    // getGoodsDataNoParams(fn) {
    //     let json_params = this.getBaseParams();
    //     this.getGoodsDataWithParams(json_params, fn);
    // },

    /**
     * 根据指定的params获取数据
     */
    getGoodsDataWithParams (params, fn) {
      //从京粉查询
      //if(!params.keyword && params.cid1===-1 && params.cid2===-1 && params.cid3===-1){
      let flg = false
      if (flg) {
        this.jf_params.app_key = params.app_key
        this.jf_params.app_secret = params.app_secret
        this.jf_params.pageIndex = params.page_index
        this.jf_params.pageSize = params.page_size
        this.jf_params.sortName = params.sortName
        this.jf_params.sort = params.sort
        this.jf_params.eliteId = 1

        this.$log('==$getSelectJFGoods==')
        this.$getSelectJFGoods(this.jf_params, (response) => {
          this.base_data_array = response.data

          if (fn) {
            this.$log(this.base_data_array)
            fn(this.base_data_array)
          }
        })
      } else {
        this.$getSelectGoods(params, (response) => {
          this.base_data_array = response.data
          if (fn) {
            // this.$log(this.base_data_array);
            fn(this.base_data_array)
          }
        })
      }
    },

    getJFGoodsDataWithParams (params, fn) {
      this.$getSelectJFGoods(params, (response) => {
        this.base_data_array = response.data
        if (fn) {
          fn(this.base_data_array)
        }
      })
    },

    /**
     * 初始化基础参数，主要将app_key和app_secret进行赋值，设置页码及每页数据个数
     */
    initAllParams () {
      if (this.all_params) {
        this.all_params.app_key = this.$common.getAppKeyInfo('70637').app_key
        this.all_params.app_secret = this.$common.getAppKeyInfo(
            '70637'
        ).app_secret
        this.all_params.pageIndex = this.page_index
        this.all_params.pageSize = this.page_size

        //默认选中分类
        // this.initCategrayTabSelected();

        //默认选中优惠券
        if (this.check_result.includes(this.check_list[0])) {
          this.all_params.isCoupon = 1
        }
        //默认选中京东自营
        if (this.check_result.includes(this.check_list[1])) {
          this.all_params.owner = 'g'
        }

        //默认选中拼购
        if (this.check_result.includes(this.check_list[2])) {
          this.all_params.isPG = 1
        }

        //默认选中爆款
        if (this.check_result.includes(this.check_list[3])) {
          this.all_params.isHot = 1
        }
        // this.$log("hasCheckBoxParam = " + this.hasCheckBoxParam);
        if (this.hasCheckBoxParam) {
          this.selectCategrayTab('-1')
        }

        if (this.search_value) {
          this.all_params.keyword = this.search_value
          this.check_result = []
          this.all_params.isCoupon = -1

          //如果
          if (this.showHome) {
            this.selectCategrayTab('-1')
          }
        }
      }
    },
  },
}
</script>

<style scoped>
.logo_icon {
  /*height: 36px;*/
  /*width: 50px;*/
  /*line-height: 36px;*/
  /*padding-top: 3px;*/
  /*margin-top: 3px;*/
  border-radius: 5px;
  margin-left: -2px;
  margin-right: 5px;
  /*font-size: 15px;*/
  /*font-stretch: extra-condensed;*/

  /*display: inline-block;*/
  /*transform: scale(1,1.5);*/
  /*-ms-transform: scale(1,1.5);*/
  /*-webkit-transform: scale(1,1.5);*/
  /*-moz-transform: scale(1,1.5);*/
  /*-o-transform: scale(1,1.5);*/
}

.changelink_icon {
  height: 41px;
  width: 100%;
  padding-top: 6px;
  border-radius: 5px;
}

.changelink_icon_round {
  height: 36px;
  width: 36px;
  padding-top: 3px;
  margin-top: 2px;
  border-radius: 20px;
  margin-left: -7px;
}

/*.search_input_out{*/
/*    margin-right: -10px;*/
/*    border-radius:5px 0px 0px 5px;*/
/*    border: 1px solid;*/
/*    background-color: white;*/
/*}*/
/*.search_button{*/
/*    height: 42px;*/
/*    border-radius: 0px 5px 5px 0px;*/
/*    margin-left: -10px*/
/*}*/

.top_tools_div {
  width: 100%;
  min-height: 50px;
  position: fixed;
  /* top: 0px; */
  z-index: 1999;
  /*box-shadow: 0px 1px 5px #999*/
}

.checkbox_sort_div_hide {
  max-height: 0px;
  -webkit-transition: max-height 0.5s;
  transition: max-height 0.5s;
  overflow: hidden;
}

.checkbox_sort_div_show {
  overflow: hidden;
  -webkit-transition: max-height 0.5s;
  transition: max-height 0.5s;
  max-height: 100px;
}

.category_hide {
    max-height: 0;
    -webkit-transition: max-height 0.3s;
    transition: max-height 0.3s;
    overflow: hidden;
}

.category_show {
    overflow: hidden;
    /*-webkit-transition: max-height 0.1s;*/
    /*transition: max-height 0.1s;*/
    max-height: 44px;
}
</style>
